module.exports = __webpack_public_path__ + "videos/hero-mobile_jp.ce7d3a6.mp4";